<div class="bg-solid-dark text-center">
    <div class="maintenance-content">
        <img src="images/wrench-logo-horizontal-light.svg" alt="Wrench Logo" class="margin-bottom-30">

        <h2 class="margin-bottom-5">We're getting some upgrades!</h2>
        <h3 class="margin-bottom-30">We should be back in <b style="white-space: nowrap;">{{timeLeft}}</b></h3>

        <div class="margin-bottom-30">
            <button mat-raised-button
                    (click)="checkMaintenance()"
                    color="primary"
                    class="width-100-percent"
                    type="button">
                <span *ngIf="!busy">Reload</span>

                <app-wrench-spinner *ngIf="busy" diameter="42"></app-wrench-spinner>
            </button>
        </div>

        <h3 class="margin-bottom-5">For immediate assistance, call</h3>
        <h2><a href="tel:8449973624">(844) 997-3624</a></h2>

    </div>
</div>
